import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { catchError, tap, throwError } from 'rxjs';
import { MyAccountType } from 'src/app/shared/types/my-account.types';
import { MyAccountAction } from './my-account.action';
import { MyAccountService } from 'src/app/services/my-account/my-account.service';

@State<MyAccountType>({
  name: 'myaccount',
  defaults: {
    userDetail: null,
    isLoading: false,
  },
})
@Injectable()
export class MyAccountState {
  static getUserDetail = () =>
    createSelector(
      [MyAccountState],
      (state: MyAccountType) => state.userDetail
    );

  static getIsLoading = () =>
    createSelector([MyAccountState], (state: MyAccountType) => state.isLoading);

  constructor(private service: MyAccountService) {}

  @Action(MyAccountAction.GetUserDetail)
  detail(
    ctx: StateContext<MyAccountType>,
    action: MyAccountAction.GetUserDetail
  ) {
    ctx.patchState({ isLoading: true });
    return this.service.getUserDetail().pipe(
      tap((data) => {
        ctx.patchState({ userDetail: data, isLoading: false });
      }),
      catchError((error) => {
        ctx.patchState({ isLoading: false });
        return throwError(() => error);
      })
    );
  }

  @Action(MyAccountAction.UpdateUserDetail)
  update(
    ctx: StateContext<MyAccountType>,
    action: MyAccountAction.UpdateUserDetail
  ) {
    return this.service.update(action.body);
  }
}
